module.exports = __webpack_public_path__ + "img/certificate1.1ff11d4e.jpeg";